var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 755.9055118110236 755.9055118110236",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l755.9055 0l0 755.9055l-755.9055 0l0 -755.9055z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "m0 0l755.9055 0l0 755.9055l-755.9055 0z",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmber);
export default __webpack_public_path__ + "static/media/Amber.49c607e8162ffa4a1ad4ce27b4ea14ca.svg";
export { ForwardRef as ReactComponent };